// Auth Action Types

// Request OTP
export const GET_OTP_REQUEST = 'auth/GET_OTP_REQUEST';
export const GET_OTP_SUCCESS = 'auth/GET_OTP_SUCCESS';
export const GET_OTP_FAILURE = 'auth/GET_OTP_FAILURE';
export const GET_OTP_RESET = 'auth/GET_OTP_RESET';

// Request OTP PVS
export const GET_OTP_PVS_REQUEST = 'auth/GET_OTP_PVS_REQUEST';
export const GET_OTP_PVS_SUCCESS = 'auth/GET_OTP_PVS_SUCCESS';
export const GET_OTP_PVS_FAILURE = 'auth/GET_OTP_PVS_FAILURE';
export const GET_OTP_PVS_RESET = 'auth/GET_OTP_PVS_RESET';

// Login
export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGIN_RESET = 'auth/LOGIN_RESET';

// Register
export const SIGNUP_REQUEST = 'auth/SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'auth/SIGNUP_FAILURE';
export const SIGNUP_RESET = 'auth/SIGNUP_RESET';

// Get user details
export const GET_USER_DETAILS_REQUEST = 'auth/GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_SUCCESS = 'auth/GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'auth/GET_USER_DETAILS_FAILURE';
export const GET_USER_DETAILS_RESET = 'auth/GET_USER_DETAILS_RESET';

// Admin dashboard data
export const GET_ADMIN_DASHBOARD_DATA_REQUEST = 'auth/GET_ADMIN_DASHBOARD_DATA_REQUEST';
export const GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'auth/GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const GET_ADMIN_DASHBOARD_DATA_FAILURE = 'auth/GET_ADMIN_DASHBOARD_DATA_FAILURE';

// Admin invoices
export const GET_ALL_INVOICES_REQUEST = 'auth/GET_ALL_INVOICES_REQUEST';
export const GET_ALL_INVOICES_SUCCESS = 'auth/GET_ALL_INVOICES_SUCCESS';
export const GET_ALL_INVOICES_FAILURE = 'auth/GET_ALL_INVOICES_FAILURE';

// Logout
export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';

// User Profile
export const GET_USER_REQUEST = 'auth/GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'auth/GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'auth/GET_USER_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'auth/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'auth/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'auth/UPDATE_PROFILE_FAILURE';
export const UPDATE_PROFILE_RESET = 'auth/UPDATE_PROFILE_RESET';

export const RESET_PROFILE_FLAG = 'auth/RESET_PROFILE_FLAG';

// Forgot Password
export const FORGOT_PASSWORD_REQUEST = 'auth/FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'auth/FORGOT_PASSWORD_FAILURE';

// Social Login
export const SOCIAL_LOGIN_REQUEST = 'auth/SOCIAL_LOGIN_REQUEST';
export const SOCIAL_LOGIN_SUCCESS = 'auth/SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'auth/SOCIAL_LOGIN_FAILURE';

export const AWARDS_FLOW_INVOKED = 'auth/AWARDS_FLOW_INVOKED';

// Reset State
export const RESET_AUTH_STATE = 'auth/RESET_AUTH_STATE';
